import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServicioFechasQueryService {
  fechaquerymin;
  fechaquerymax;

  constructor() { }
}
